<div class="row g-1">
	<div class="col-9">
		<div class="row g-1">
			<div class="col">
				<div class="card mb-0">
					<div class="card-header py-0 px-1 my-0">
						<h5 class="card-title mb-0 text-center">
							Task Management
						</h5>
					</div>
					<div class="card-body px-2 py-1">
						<mat-accordion [hideToggle]="false">
							<mat-expansion-panel [expanded]="true">
								<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'"
									[expandedHeight]="'40px'">
									<mat-panel-title>
										<strong class="text-white">
											<fa-icon [icon]="['fas','filter']"></fa-icon>
											Filters
										</strong>
									</mat-panel-title>
									<mat-panel-description>
										@if(showDownloadExcelBtn()){
										<button class="btn btn-xs btn-light" matTooltip="Excel"
											[matTooltipPosition]="'below'" (click)="getTasksExcel($event)"
											[disabled]="excelLoader">
											<fa-icon *ngIf="!excelLoader"
												[icon]="['fas', 'cloud-download-alt']"></fa-icon>
											<fa-icon *ngIf="excelLoader" [icon]="['fas', 'spinner']"
												animation="spin"></fa-icon>
										</button>
										}
									</mat-panel-description>
								</mat-expansion-panel-header>
								<div class="row g-1 mt-2">
									<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
										<div class="ng-select-default">
											<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
												placeholder="Department" [(ngModel)]="filters.department"
												id="department" appendTo="body" (change)="getAllTasks()"
												[disabled]="disableDepartment">
											</ng-select>
										</div>
									</div>
									<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<div class="ng-select-default">
											<ng-select [items]="userList" bindValue="id" bindLabel="full_name"
												[clearable]="true" placeholder="Lead" [(ngModel)]="filters.lead"
												id="lead" appendTo="body" (change)="getAllTasks()">
											</ng-select>
										</div>
									</div>
									<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<div class="ng-select-default">
											<ng-select [items]="userList" bindValue="id" bindLabel="full_name"
												[clearable]="true" placeholder="Assigned To"
												[(ngModel)]="filters.assigned" id="assigned" appendTo="body"
												(change)="getAllTasks()">
											</ng-select>
										</div>
									</div>
									<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
										<div class="input-group mt--7">
											<input class="form-control" placeholder="Due From"
												[(ngModel)]="filters.due_date_start" ngbDatepicker id="due_date_start"
												#due_date_start="ngbDatepicker" [minDate]="minDate" [container]="'body'"
												(ngModelChange)="getAllTasks()" />
											<button class="btn btn-outline-secondary" (click)="due_date_start.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
									</div>
									<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
										<div class="input-group mt--7">
											<input class="form-control" placeholder="Due To"
												[(ngModel)]="filters.due_date_end" ngbDatepicker id="due_date_end"
												#due_date_end="ngbDatepicker" [minDate]="minDate" [container]="'body'"
												(ngModelChange)="getAllTasks()" />
											<button class="btn btn-outline-secondary" (click)="due_date_end.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
									</div>
								</div>
								<div class="row g-1 mt-1">
									<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
									<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
									<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<div class="input-group">
											<input class="form-control" [formControl]="searchControl"
												placeholder="Search" id="searchControl">
											<button class="btn btn-outline-secondary" type="button"
												*ngIf="searchControl.value" (click)="clearSearchInput()">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
										</div>
									</div>
								</div>
							</mat-expansion-panel>
						</mat-accordion>
					</div>
				</div>
			</div>
		</div>
		<div class="row g-1">
			@for (status of statusList; track $index){
			<div class="col">
				<div class="card mb-0" [ngStyle]="getColor1(status)">
					<div class="card-body p-1">
						<h5 class="card-title mb-0 text-center" style="color: inherit;">
							{{status.name}}
							@if (status.name == todoStatusName && navbar.user?.tms_access?.create_task) {
							<button type="button" class="btn btn-xs btn-light float-end" (click)="createEditTask(null)">
								<fa-icon [icon]="['fas', 'plus']"></fa-icon>
								Create
							</button>
							}
						</h5>
					</div>
				</div>
			</div>
			}
		</div>
		<div class="row g-1">
			@for (tasks of taskList; track $index) {
			<div class="col">
				<div class="card mb-0">
					<div class="card-body p-1">
						@if(showScroll){
						<cdk-virtual-scroll-viewport itemSize="50"
							(scrolledIndexChange)="$event+7>=tasks.list.length?getTasks($index):null" cdkDropList
							id="{{tasks.id}}" [cdkDropListData]="tasks.list"
							[cdkDropListConnectedTo]="tasks.connectedTo" (cdkDropListDropped)="drop($event)"
							(cdkDropListEntered)="onDragEntered(tasks.id)" (cdkDropListExited)="onDragExited()"
							[ngClass]="dragEnteredId==tasks.id?'dragged':''">
							<div *cdkVirtualFor="let item of tasks.list; let i = index" cdkDrag
								[cdkDragDisabled]="dragDisabled(item)" class="card p-2"
								[ngStyle]="{cursor:dragDisabled(item)?'':'move','border-color':getColor(item)['background-color']}"
								(click)="taskClick(item)">
								<div class="card-body task-card-body p-0 task-body-bg">
									<div class="row g-0">
										<div class="col">
											<h4 class="mb-0">
												<strong class="float-start fs-smaller">
													{{item.unique_id}}
													@if(moveLoader == item.id){
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}
												</strong>
												<strong class="float-end ms-1 fs-smaller">
													DD:{{ item.due_date }}
												</strong>
												@if (isDueDatePassed(item)) {
												<fa-icon [icon]="['fas','exclamation-triangle']"
													class="text-red float-end fs-smaller"
													matTooltip="Due date passed"></fa-icon>
												}
											</h4>
										</div>
									</div>
									<div class="row g-0">
										<div class="col fs-smaller">
											<p class="mb-2">
												{{ item.sub_task }}
											</p>
										</div>
									</div>
									<div class="row g-0">
										<div class="col fs-smaller">
											<p class="mb-0">
												A&nbsp;:&nbsp;{{ item.assigned_name }}
											</p>
											<p class="mb-0">
												L&nbsp;:&nbsp;{{ item.lead_name }}
												@if (this.navbar.user?.tms_access?.delete_task) {
												<button type="button" class="btn btn-xs btn-danger float-end ms-1"
													(click)="deleteTask($event,item)" matTooltip="Delete">
													@if(deleteLoader == item.id){
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}@else {
													<fa-icon [icon]="['fas','trash-alt']"></fa-icon>
													}
												</button>
												}
											</p>
										</div>
									</div>
								</div>
							</div>
							@if(!tasks.list.length && !tasks.isListLoading){
							<div class="text-center">
								<img src="../../../assets/img/empty-box.png" class="empty-img" alt="No task image"
									matTooltip="List empty" />
							</div>
							}
							@if(tasks.isListLoading){
							<p class="text-center text-bold">
								<mat-spinner style="margin: 0 auto;"></mat-spinner>
							</p>
							}@else if(!tasks.isListFinished){
							<div class="text-center">
								<button (click)="getTasks($index)" class="btn-primary btn btn-sm">
									Load More
								</button>
							</div>
							}
						</cdk-virtual-scroll-viewport>
						}
						<!-- @if(tasks.isListLoading){
						<p class="text-center text-bold">
							<mat-spinner style="margin: 0 auto;"></mat-spinner>
						</p>
						} -->
					</div>
				</div>
			</div>
			}
		</div>
	</div>
	<div class="col-3">
		<div class="row g-1">
			<div class="col">
				<div class="card mb-0">
					<div class="card-body p-1">
						<div class="news-ticker-container rounded bg-secondary">
							<div class="news-ticker-title underline">
								Events
							</div>
							<div class="news-ticker">
								<ul>
									@if (loadingEvents) {
									<li>
										<p class="text-center mb-0">
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											Loading
										</p>
									</li>
									}@else {
									@if (eventList.length) {
									@for (item of eventList; track $index) {
									<li>
										<p class="mb-0" (click)="viewEvent(item)" role="button">
											<strong>
												{{item.date}}
												-
												{{item.name}}
											</strong>
										</p>
									</li>
									}
									}@else {
									<li>
										<p class="text-center mb-0">
											<img src="../../../assets/img/empty-box.png" class="empty-img"
												alt="No task image" matTooltip="List empty" />
										</p>
									</li>
									}
									}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="card mb-0">
					<div class="card-body p-1">
						<div class="news-ticker-container rounded bg-secondary">
							<div class="news-ticker-title underline">
								Company News Board
							</div>
							<div class="news-ticker">
								<ul>
									@if (loadingNews) {
									<li>
										<p class="text-center mb-0">
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											Loading
										</p>
									</li>
									}@else {
									@if (newsList.length) {
									@for (item of newsList; track $index) {
									<li>
										@if(item.link){
										<a [href]="item.link" target="_blank">
											<ng-container *ngTemplateOutlet="news_temp; context: { $implicit: item }">
											</ng-container>
										</a>
										}@else {
										<p class="mb-0">
											<ng-container *ngTemplateOutlet="news_temp; context: { $implicit: item }">
											</ng-container>
										</p>
										}
									</li>
									}
									}@else {
									<li>
										<p class="text-center mb-0">
											<img src="../../../assets/img/empty-box.png" class="empty-img"
												alt="No task image" matTooltip="List empty" />
										</p>
									</li>
									}
									}
								</ul>
								<ng-template #news_temp let-item>
									<strong>
										{{item.news}}
									</strong>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-task-form [statusList]="statusList" [userList]="userList" (created)="getAllTasks()">
</app-task-form>
<div class="modal fade" id="viewEventModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">
					<strong>
						{{eventToView?.date}}
						-
						{{eventToView?.name}}
					</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>#</th>
									<th>Departments</th>
								</tr>
							</thead>
							<tbody>
								@if (eventToView?.departments.length) {
								@for (depId of eventToView?.departments; track $index) {
								<tr>
									<td>{{$index + 1}}</td>
									<td>{{getDepartmentName(depId)}}</td>
								</tr>
								}
								}@else {
								<tr>
									<td colspan="2" class="text-center">Departments not added</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					Ok
				</button>
			</div>
		</div>
	</div>
</div>